namespace Matrix.Data {
    export class ExtensionFieldColumns {
        static columnsKey = 'Data.ExtensionField';
    }
}
